module.exports = __webpack_public_path__ + "static/media/ajax-Loader.c352e05f.gif";